import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import * as authService from '../services/authService';
import { setStoredTokens } from '../services/api';
import './Login.css';

const Login: React.FC = () => {
  const [modo, setModo] = useState<'login' | 'registroEmpresa'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nombreEmpresa, setNombreEmpresa] = useState('');
  const [nombreAdmin, setNombreAdmin] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const limpiarFormulario = () => {
    setEmail('');
    setPassword('');
    setNombreEmpresa('');
    setNombreAdmin('');
    setError(null);
  };

  const cambiarModo = () => {
    limpiarFormulario();
    setModo(modo === 'login' ? 'registroEmpresa' : 'login');
  };

  const manejarLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setCargando(true);

    try {
      await login(email, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al iniciar sesion');
    } finally {
      setCargando(false);
    }
  };

  const manejarRegistroEmpresa = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setCargando(true);

    try {
      const response = await authService.registrarEmpresa({
        nombreEmpresa,
        nombreAdmin,
        emailAdmin: email,
        password,
      });
      setStoredTokens(response.token, response.refreshToken);
      await login(email, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al registrar la empresa');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <i className={`fas ${modo === 'login' ? 'fa-calendar-check' : 'fa-building'} login-icon`}></i>
          <h1>Sistema de Vacaciones</h1>
          <p>{modo === 'login' ? 'Ingrese sus credenciales para continuar' : 'Registre su empresa'}</p>
        </div>

        <form onSubmit={modo === 'login' ? manejarLogin : manejarRegistroEmpresa} className="login-form">
          {error && (
            <div className="login-error">
              <i className="fas fa-exclamation-circle"></i>
              <span>{error}</span>
            </div>
          )}

          {modo === 'registroEmpresa' && (
            <>
              <div className="form-group">
                <label htmlFor="nombreEmpresa">
                  <i className="fas fa-building"></i>
                  Nombre de la Empresa
                </label>
                <input
                  id="nombreEmpresa"
                  type="text"
                  value={nombreEmpresa}
                  onChange={(e) => setNombreEmpresa(e.target.value)}
                  placeholder="Ej: Mi Empresa S.A."
                  required
                  disabled={cargando}
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label htmlFor="nombreAdmin">
                  <i className="fas fa-user"></i>
                  Nombre del Administrador
                </label>
                <input
                  id="nombreAdmin"
                  type="text"
                  value={nombreAdmin}
                  onChange={(e) => setNombreAdmin(e.target.value)}
                  placeholder="Ej: Juan Perez"
                  required
                  disabled={cargando}
                />
              </div>
            </>
          )}

          <div className="form-group">
            <label htmlFor="email">
              <i className="fas fa-envelope"></i>
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="correo@empresa.com"
              required
              disabled={cargando}
              autoFocus={modo === 'login'}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i>
              Contrasena
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={modo === 'login' ? 'Ingrese su contrasena' : 'Minimo 6 caracteres'}
              required
              minLength={modo === 'registroEmpresa' ? 6 : undefined}
              disabled={cargando}
            />
          </div>

          <button type="submit" className="login-button" disabled={cargando}>
            {cargando ? (
              <>
                <div className="login-spinner"></div>
                {modo === 'login' ? 'Ingresando...' : 'Registrando empresa...'}
              </>
            ) : (
              <>
                <i className={`fas ${modo === 'login' ? 'fa-sign-in-alt' : 'fa-building'}`}></i>
                {modo === 'login' ? 'Iniciar Sesion' : 'Registrar Empresa'}
              </>
            )}
          </button>
        </form>

        <div className="login-toggle">
          {modo === 'login' ? (
            <p>Quiere registrar su empresa? <button type="button" onClick={cambiarModo}>Registrar empresa</button></p>
          ) : (
            <p>Ya tiene cuenta? <button type="button" onClick={cambiarModo}>Iniciar sesion</button></p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
